module.exports = __webpack_public_path__ + "static/x46-55dfb6199e0e6a63053cae1b8c8888f7.png";